module.exports = __webpack_public_path__ + "images/imagepeople1.2855390b.png";